import React, { useState, useEffect } from 'react';
import './Header.css';

const Header = () => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Set sticky when scrolled past 100px
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`professional-header ${isSticky ? 'sticky' : ''}`}>
      <div className="header-content">
        <div className="name-title">
          <h1>Dr. Dipti Vashisth Sharma</h1>
          <p>PhD Economics | Assistant Professor Professor | Researcher</p>
        </div>

        <div className="contact-details">
          <a href="mailto:vs.dipti@gmail.com" className="contact-item">
            <span className="icon">📧</span>
            <span>vs.dipti@gmail.com</span>
          </a>

          <a href="tel:+918805352101" className="contact-item">
            <span className="icon">📱</span>
            <span>+91 8805352101</span>
          </a>

          <a
            href="https://orcid.org/0009-0001-4305-141X"
            className="contact-item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="icon">🆔</span>
            <span>ORCID ID: 0009-0001-4305-141X</span>
          </a>

          <a
            href="https://www.scopus.com/authid/detail.uri?authorId=59002389100"
            className="contact-item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="icon">📚</span>
            <span>Scopus ID: 59002389100</span>
          </a>
        </div>


      </div>

      <nav className={`professional-nav ${isSticky ? 'sticky-nav' : ''}`}>
        <div className="nav-container">
          <ul className="nav-items">
            <li><a href="#experience">Experience</a></li>
            <li><a href="#education">Education</a></li>
            <li><a href="#research">Research & Patents</a></li>
            <li><a href="#awards">Awards</a></li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;

